import { render, staticRenderFns } from "./customer-service-card.vue?vue&type=template&id=fdccefcc&scoped=true"
import script from "./customer-service-card.vue?vue&type=script&lang=js"
export * from "./customer-service-card.vue?vue&type=script&lang=js"
import style0 from "./customer-service-card.vue?vue&type=style&index=0&id=fdccefcc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdccefcc",
  null
  
)

export default component.exports